



































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import TableRoute from '@c/tables/TableRoute.vue';
import {
  IpModuleInterface,
  PModule,
  PModuleTableHeader,
  PModuleWithMeasurements,
} from './interfaces';
import {PMProcessActionType, PMProcessStatus} from './enums';
import pmoduleStoreModule from '@/store/modules/entities/pmodules/pmoduleModule';
import {Can} from '@casl/vue';

import enumsModule from '@/store/modules/enumsModule';
import {TypeData} from '@/api/configurate';
import {PModuleType, RegnumType} from '@/enums/configs';
import {
  pmoduleDataRoutesByTypeMap,
  pmoduleDeveloperInfoDataRoutesByTypeMap,
  pmoduleStoresByTypeMap,
} from '@v/system/modules/configurate';
import {httpClient} from '@/api/baseApi';
import axios from 'axios';
import MeasurementDialog from '@/components/MeasurementDialog.vue';
import {isNumber, isString} from '@/utils/commonUtils';

@Component({
  components: {
    TableRoute,
    Can,
    MeasurementDialog,
  },
})
export default class Modules extends Vue {
  pmoduleTypes: IpModuleInterface[] = [];

  get types(): TypeData[] {
    // На странице датчиков добавлять только датчики, на странице ПМ — только программные модули
    const wanted = this.isSensorPage ? RegnumType.SensorModule : RegnumType.ProgramModule;
    return enumsModule.moduleTypes
      .filter(x => !x.url.startsWith('monitor'))
      .filter(x => x.regnum_type === wanted)
      .map(x => ({
        id: x.value.toString(),
        type: x.value as PModuleType,
        name: x.description.replace('dtcp ', ''),
        enabled: true,
      }));
  }

  statusesWS: WebSocket | null = null;

  modulesWS: WebSocket | null = null;

  // Строка поиска
  search = '';

  typeSearch: PModuleType | null = null;

  pmListCash: PModule[] = [];

  selectedPmModule!: PModuleWithMeasurements;

  nameOfModule!: string;

  isSensorPage = false;

  fullListModelTypes: IpModuleInterface[] = [];

  fullHeaders: PModuleTableHeader[] = [
    {
      text: 'Наименование',
      value: 'name',
      sortable: true,
    },
    {
      text: 'Тип',
      value: 'typeDescription',
      sortable: true,
    },
    {
      text: 'Статус',
      value: 'status',
      sortable: true,
    },
  ];

  headers = this.fullHeaders;

  canViewModulesOrSensors() {
    return this.isSensorPage ? 'sensors_journal' : 'modules_journal';
  }

  canEditModulesOrSensors() {
    return this.isSensorPage ? 'sensors_journal' : 'modules_journal';
  }

  getTypeRegnum(typeValue: any): string | undefined {
    const item = this.fullListModelTypes.find(x => x.value === typeValue);
    return item?.regnum_type;
  }

  getShortList(list: any, name = 'value') {
    // На странице датчиков — только датчики, на странице ПМ — только программные модули
    const wanted = this.isSensorPage ? RegnumType.SensorModule : RegnumType.ProgramModule;
    return list.filter((item: any) => this.getTypeRegnum(item[name]) === wanted);
  }

  filterList(data: PModule[]) {
    const list = data.map((item: any) => {
      const typeName: any = this.fullListModelTypes.find(
        (itemType: IpModuleInterface) => itemType.value === item.type,
      )?.value;

      return {
        ...item,
        typeName,
      };
    });

    return this.getShortList(list, 'typeName');
  }

  getSelectFilterList(data: any) {
    return this.getShortList(data);
  }

  get apiStore() {
    if (!this.pmListCash.length && pmoduleStoreModule.all && pmoduleStoreModule.all.length) {
      pmoduleStoreModule.all.forEach(x => {
        this.pmListCash.push(x);
      });
    }
    return pmoduleStoreModule;
  }

  get typesStoreMap() {
    return pmoduleStoresByTypeMap;
  }

  @Watch('isSensorPage')
  onChangePage(val: boolean) {
    this.headers = val
      ? this.fullHeaders.filter(item => item.value !== 'status')
      : this.fullHeaders;
  }

  @Watch('pmListCash')
  onChangePmListCash(val: any) {
    const newList = this.filterList(val);
    pmoduleStoreModule.filterListAction(newList);
  }

  // Фильтруем журнал по наименованию при изменении контрола
  @Watch('search')
  onSearch(newVal: string) {
    this.pmFiltering(newVal, this.typeSearch);
  }

  @Watch('$route')
  async onChangeRoute(val: any) {
    this.search = '';
    this.typeSearch = null;
    this.isSensorPage = val.path.includes('sensors');
    const newList = this.filterList(this.pmListCash);

    pmoduleStoreModule.filterListAction(newList);

    this.pmoduleTypes = this.getSelectFilterList(this.fullListModelTypes);
    await this.subscribeStatusesWS();
  }

  // Фильтруем журнал по типу при изменении контрола
  @Watch('typeSearch')
  onTypeSearch(newVal: string) {
    this.pmFiltering(this.search, newVal);
  }

  // метод при использовании двух фильтров одновременно
  pmFiltering(name: string, type: any) {
    const moduleStoreModule = this.pmListCash;

    let newList: PModule[];

    if (!name) {
      newList = this.pmListCash;
    } else {
      newList = moduleStoreModule.filter((x: any) =>
        x.name
          .toLowerCase()
          .trim()
          .includes(name.toLowerCase().trim()),
      );
    }
    if (type) {
      newList = newList.filter((x: any) => x.type == type);
    }
    pmoduleStoreModule.filterListAction(this.filterList(newList));
  }

  isModuleActive(item: PModule) {
    return item.processStatus == PMProcessStatus.Active;
  }

  isModuleExecutable(item: PModule) {
    // TODO: костыль, сделать нормально, когда будет возможно!
    return [
      PModuleType.CrmModule,
      PModuleType.DtcpServerModule,
      PModuleType.HeaterMonitorModule,
      PModuleType.CleanStorageModule,
      PModuleType.ServerMonitorModule,
      PModuleType.BearingControlModule,
      PModuleType.PingerModule,
      PModuleType.SignalTrendModule,
      PModuleType.StatsCollectorModule,
    ].includes(item.type);
  }

  isModuleHasDeveloperInfo(item: PModule) {
    // TODO: костыль, сделать нормально, когда будет возможно!
    return [
      PModuleType.DtcpTahoModule,
      PModuleType.CrmModule,
      PModuleType.DtcpServerModule,
      PModuleType.DtcpAccelerometerModule,
      PModuleType.DtcpTemperatureModule,
      PModuleType.DtcpEnergyModule,
      PModuleType.HeaterMonitorModule,
      PModuleType.CleanStorageModule,
      PModuleType.ServerMonitorModule,
      PModuleType.BearingControlModule,
      PModuleType.PingerModule,
      PModuleType.DtcpEmulatorModule,
    ].includes(item.type);
  }

  async subscribeStatusesWS() {
    if (!this.isSensorPage) {
      this.statusesWS = await pmoduleStoreModule.statusesChangesWSConnection();
      if (this.statusesWS) {
        this.statusesWS.onmessage = async (e: {data: string}) => {
          const parsedData = JSON.parse(e.data);
          await pmoduleStoreModule.updateStatuses({statusMap: parsedData});
        };
      }
    } else {
      await this.closeWS();
    }

    this.modulesWS = await pmoduleStoreModule.modulesChangesWSConnection();
    if (this.modulesWS) {
      this.modulesWS.onmessage = async (e: {data: string}) => {
        const parsedData = JSON.parse(e.data) as {_id: string; data: {status: string}};
        await pmoduleStoreModule.updateModules(parsedData);
      };
    }
  }

  async created() {
    const currentUrl = this.$route.path;
    this.isSensorPage = currentUrl.includes('sensors');
    const newList = this.filterList(this.pmListCash);
    pmoduleStoreModule.filterListAction(newList);

    await this.loadPModuleTypes();
    await this.subscribeStatusesWS();
  }

  /*
    Переход на страницу показа данных
  */
  async showModuleView(item: any) {
    const {href} = this.$router.resolve({
      name: pmoduleDataRoutesByTypeMap.get(item.type),
      params: {id: `${item.id}`},
    });
    window.open(href, '_blank');
  }

  isModuleHasView(item: any) {
    return pmoduleDataRoutesByTypeMap.has(item.type);
  }

  /*
    Перезапуск процесса ПМ
  */
  async restart(item: any) {
    const module = this.typesStoreMap.get(item.type) as any;
    if (!module) return;
    await module.processAction({
      id: item.id,
      action: PMProcessActionType.Restart,
    });
  }

  /*
    Остановка процесса ПМ
  */
  async stop(item: any) {
    const module = this.typesStoreMap.get(item.type) as any;
    if (!module) return;
    await module.processAction({
      id: item.id,
      action: PMProcessActionType.Stop,
    });
  }

  /*
    Запуск процесса ПМ
  */
  async start(item: any) {
    const module = this.typesStoreMap.get(item.type) as any;
    if (!module) return;
    await module.processAction({
      id: item.id,
      action: PMProcessActionType.Start,
    });
  }

  /*
    Переход на страницу показа данных
  */
  async showDeveloperModuleInfo(item: any) {
    const {href} = this.$router.resolve({
      name: pmoduleDeveloperInfoDataRoutesByTypeMap.get(item.type),
      params: {id: `${item.id}`},
    });
    window.open(href, '_blank');
  }

  beforeDestroy() {
    this.closeWS();
  }

  // Закрыть соединение веб сокета
  async closeWS() {
    if (this.statusesWS) {
      this.statusesWS.close();
      this.statusesWS = null;
    }
    if (this.modulesWS) {
      this.modulesWS.close();
      this.modulesWS = null;
    }
  }

  get measurementDialog() {
    return this.$refs.measurementDialog as any;
  }

  // Загрузка программных модулей
  async loadPModuleTypes() {
    // Типы уже загружаются глобальным guard'ом в enumsModule (один запрос /api/module_types/),
    // чтобы не дублировать запрос
    if (!enumsModule.moduleTypes.length) {
      await enumsModule.fetchAll();
    }

    if (!this.fullListModelTypes.length) {
      this.fullListModelTypes = enumsModule.moduleTypes.map(x => ({...x, type: x.value}));
    }

    if (this.fullListModelTypes.length) {
      this.pmoduleTypes = this.getSelectFilterList(this.fullListModelTypes);
    }
  }

  module!: any;

  // событие, срабатывающее при нажатии на кнопку
  async changeBoundary(item: any) {
    // загружаем ПМ
    const mod = this.pmoduleTypes.filter((type: any) => type.value == item.type);
    const {data} = await httpClient.get(`${mod[0].url}/${item.id}`);
    this.selectedPmModule = data;
    this.nameOfModule = this.selectedPmModule.name;

    const newMeasForm: any = [];

    // так как запрос вернул нам поля с другими названиями (с _ ), меняем названия полей на новые
    const measurement = this.selectedPmModule?.measurements;
    if (measurement?.length) {
      measurement.forEach((meas: any) => {
        const modal: any = {
          measurementId: meas.module_type_measurement_id,
          measurementDescription: meas.module_type_measurement_description,
          topWarningBoundary: meas.top_warning_boundary,
          topDangerBoundary: meas.top_danger_boundary,
          topErrorBoundary: meas.top_error_boundary,
          bottomWarningBoundary: meas.bottom_warning_boundary,
          bottomDangerBoundary: meas.bottom_danger_boundary,
          bottomErrorBoundary: meas.bottom_error_boundary,
        };
        newMeasForm.push(modal);
      });
    }
    this.selectedPmModule.type = item.type;
    this.selectedPmModule.measurements = newMeasForm;

    this.module = this.selectedPmModule;

    const dialog = this.$refs.measurementDialog as any;
    const options = {
      saveCallback: async () => {
        dialog.$refs.form.reset();
        // TODO: переделать с получением data
        await this.saveMeasCallback();
        dialog.close();
      },
    };
    //TODO: CancelToken и axios должен быть в store
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const request = {
      data: {
        bottomDangerBoundary: 0,
        bottomErrorBoundary: 0,
        bottomWarningBoundary: 0,
        editableBoundaries: {},
        isActive: false,
        isNew: false,
        measurementDescription: '',
        measurementId: 0,
        parent: {},
        topDangerBoundary: 0,
        topErrorBoundary: 0,
        topWarningBoundary: 0,
      },
    };

    this.measurementDialog.openDialog(this.selectedPmModule, item.type, options, source, request);
  }

  setNumberValue(value: any) {
    if (isString(value)) {
      const num = Number(value);
      if (isNumber(num)) return num;
    }
    return value;
  }

  async saveMeasCallback() {
    try {
      this.module.measurements = this.module.measurements.filter((x: any) => x.isActive === true);
      this.module.measurements.forEach((meas: any) => {
        this.setNumberValue(meas.topWarningBoundary);
        this.setNumberValue(meas.topDangerBoundary);
        this.setNumberValue(meas.topErrorBoundary);
        this.setNumberValue(meas.bottomWarningBoundary);
        this.setNumberValue(meas.bottomDangerBoundary);
        this.setNumberValue(meas.bottomErrorBoundary);
      });
      if (!isString(this.module.id)) this.module.id = this.module.id.toString();
      this.module.name = this.nameOfModule;
      const store = this.typesStoreMap.get(this.module.type) as any;
      if (!store) return;
      store.save(this.module);
      this.$emit('change');
    } catch {
      throw new Error('Ошибка сохранения');
    }
  }
}
